import React from 'react';
import { moduleConfigurations } from './moduleConfigurations';
import { modulePaths } from './modulePaths';
import { ModuleName, ModuleProps } from './types';
import { useProtectedPage } from './useProtectedPage';
import { useRequirePaymentProvider } from './useRequirePaymentProvider';
import { useWaitForShopToken } from './useWaitForShopToken';

const useModuleConfig = (path: ModuleName) => {
  const config = moduleConfigurations[path];
  useProtectedPage(config);
  useRequirePaymentProvider(config.requires);
  return config;
};

export const Module: React.FC<ModuleProps> = ({ path, ...props }) => {
  const { waitFor } = useModuleConfig(path);
  const isLoading = useWaitForShopToken(waitFor);
  if (isLoading) {
    return null;
  }
  return <>{path in modulePaths ? modulePaths[path](props) : `${path} not available`}</>;
};
